import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs-make";

export default class extends Controller {
  static values = {
    reorderUrlTemplate: String,
  };

  connect() {
    this.setupSortable();
  }

  disconnect() {
    this.destroySortable();
  }

  setupSortable() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-playlist-grid-handle]",
      filter: "[data-sortable-exclude]",
      fallbackOnBody: true,
      forceFallback: true,
      swapThreshold: 0.65,
      onMove: (event) => {
        return !event.related.hasAttribute("data-sortable-exclude");
      },
      onStart: () => {
        this.element.style.userSelect = "none";
      },
      onEnd: (...args) => {
        this.element.style.userSelect = "";
        this.onReorder(...args);
      },
    });
  }

  destroySortable() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  onReorder(event) {
    const id = event.item.dataset.playlistItemId;
    const sortableItems = [...this.element.children].filter(
      (el) => !el.hasAttribute("data-sortable-exclude")
    );
    const newPosition = sortableItems.indexOf(event.item) + 1;
    const url = this.reorderUrlTemplateValue.replace("__ID__", id);

    this.patchReorder(url, newPosition);
  }

  get csrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
  }

  patchReorder(url, newPosition) {
    const data = new FormData();
    data.append("playlist_item[new_position]", newPosition);

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
      body: data,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Reorder failed");
      })
      .catch((error) => {
        console.error("Reorder error:", error);
        window.location.reload();
      });
  }
}
